









import { Component, Vue, Prop } from 'vue-property-decorator';
import { Slider } from '@/models/Slider';
import ImagePopup from '@/components/Inspiration/ImagePopup.vue';

@Component({
    components: {
        ImagePopup
    }
})
export default class ThumbnailSlider extends Vue {
    @Prop({ default: () => [] }) thumbs!: Slider['thumbs'];

    constructor() {
        super();
    }

    get getThumbs(): Slider['thumbs'] {
        return typeof this.thumbs === 'string' ? JSON.parse(this.thumbs) : this.thumbs;
    }

    imagePopup(imageUrl: string) {
        this.$modal.show(
            ImagePopup,
            {
                imageUrl,
                class: 'product-image-slider__modal'
            },
            {
                adaptive: false,
                height: '90%',
                width: '90%',
                maxWidth: 1500,
                scrollable: false
            }
        );
    }
}
